import StartingScreen from './StartingScreen.jsx';

export default StartingScreen;